(() => {
  'use strict';

  if (window.dancingOaksExternalSearchImageCycle) return;
  window.dancingOaksExternalSearchImageCycle = true;

  const cardSelector = [
    '.os-index-products .product-card',
    '.omega__autocomplete .omega__products',
    '.omega__autocomplete .omega__product',
    '.predictive-search__item--link-with-thumbnail',
    '.sale-product-card__link',
  ].join(',');
  const imageSelector = '.product-card__image, .omega__image img, .predictive-search__image, .sale-product-card__media img';
  const hoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const states = new WeakMap();
  const productRequests = new Map();
  const initialDelay = 1500;
  const interval = 2200;

  const isEligible = () => hoverPointer.matches && !reducedMotion.matches;
  const normalizeUrl = (url) => new URL(url, window.location.origin).href;
  const imageKey = (url) => {
    const parsed = new URL(url, window.location.origin);
    parsed.searchParams.delete('width');
    return `${parsed.pathname}?${parsed.searchParams}`;
  };

  function productJsonUrl(card) {
    const link = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
    if (!link) return '';
    const match = new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
    return match ? `${window.Shopify?.routes?.root || '/'}products/${match[1]}.js` : '';
  }

  function loadProduct(url) {
    if (!productRequests.has(url)) {
      productRequests.set(
        url,
        fetch(url, { headers: { Accept: 'application/json' } })
          .then((response) => {
            if (!response.ok) throw new Error('Unable to load product photos');
            return response.json();
          })
          .catch(() => null)
      );
    }
    return productRequests.get(url);
  }

  async function prepare(state) {
    if (state.frames) return state.frames;
    const url = productJsonUrl(state.card);
    const product = url ? await loadProduct(url) : null;
    const original = normalizeUrl(state.image.currentSrc || state.image.src);
    const candidates = Array.isArray(product?.images) ? product.images : [];
    const originalKey = imageKey(original);
    const urls = [
      original,
      ...candidates.map(normalizeUrl).filter((candidate) => imageKey(candidate) !== originalKey),
    ].filter((value, index, values) => values.findIndex((candidate) => imageKey(candidate) === imageKey(value)) === index);
    state.frames = urls.slice(0, 3).map((src, index) => ({ ready: index === 0, src }));

    state.frames.slice(1).forEach((frame) => {
      const preload = new Image();
      frame.preload = preload;
      preload.addEventListener('load', () => { frame.ready = true; }, { once: true });
      preload.src = frame.src;
      if (preload.complete && preload.naturalWidth > 0) frame.ready = true;
    });
    return state.frames;
  }

  function show(state, index) {
    const frame = state.frames?.[index];
    if (!frame?.ready) return false;
    state.image.removeAttribute('srcset');
    state.image.src = frame.src;
    state.index = index;
    return true;
  }

  function schedule(state, delay) {
    window.clearTimeout(state.timer);
    if (!state.hovering || !isEligible() || (state.frames?.length || 0) < 2) return;
    state.timer = window.setTimeout(() => {
      const next = (state.index + 1) % state.frames.length;
      if (show(state, next)) schedule(state, interval);
      else schedule(state, 100);
    }, delay);
  }

  async function enter(card) {
    if (!isEligible()) return;
    let state = states.get(card);
    if (!state) {
      const image = card.querySelector(imageSelector);
      if (!image || image.classList.contains('dancing-oaks-placeholder')) return;
      state = { card, frames: null, hovering: false, image, index: 0, timer: null };
      states.set(card, state);
    }
    if (state.hovering) return;
    state.hovering = true;
    const enteredAt = performance.now();
    await prepare(state);
    if (!state.hovering) return;
    schedule(state, Math.max(0, initialDelay - (performance.now() - enteredAt)));
  }

  function leave(card) {
    const state = states.get(card);
    if (!state) return;
    state.hovering = false;
    window.clearTimeout(state.timer);
    state.timer = null;
    if (state.frames?.length) show(state, 0);
  }

  document.addEventListener('pointerover', (event) => {
    const card = event.target.closest?.(cardSelector);
    if (!card || card.contains(event.relatedTarget)) return;
    enter(card);
  });

  document.addEventListener('pointerout', (event) => {
    const card = event.target.closest?.(cardSelector);
    if (!card || card.contains(event.relatedTarget)) return;
    leave(card);
  });
})();
